module.exports = __webpack_public_path__ + "media/images/filters/checkbox-checked-7fe641fc35021fb1ad66160552736c97.png";